<br>
<div>
    <div class="textBlock">
        <div>
            <p class="h2 text-center">Halte 8</p>
            <hr>
        </div>
        <div>
            <div class="text-center">
                <p class="h4 text-center">
                    Navigatie
                </p>
                <hr>
                <p class="text-center d-block margin">
                    Wandel via de Paalstraat en de Jozef Jennesstraat terug naar de chiro.                 
                </p>
                <hr class="afterImage">
                <p class="h4 text-center">
                    Denkertje
                </p>
                <hr>
                <p class="text-center d-block margin">
                    Misschien heb je van al dat wandelen wel honger gekregen. Dat brengt ons bij de laatste vraag. Wat is het lekkerste dat je ooit in de chiro of op kamp hebt gegeten? Wat mag van jou zeker niet ontbreken in het grote chiro-kookboek?                 
                </p>
                <p class="text-center d-block margin">
                    En misschien kan je dat thuis ook wel eens proberen te maken? Wat denk je?                
                </p>
            </div>
        </div>
    </div>
    <div class="text-center buttonMargin">
        <button type="button" class="btn btn-primary" [routerLink]="'/einde'">Beëindigen</button>
    </div>
</div>